import Header from "../../component/header";
import Footer from "../../component/footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const base_Url = process.env.REACT_APP_API_URL;

function Services() {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${base_Url}/Blog/0`);
        const data = await response.json();
        if (data.status.code === 1 && data.data.length > 0) {
          // Get the first array of blogs and take the last 3
          const allBlogs = data.data[0];
          const lastThreeBlogs = allBlogs.slice(-3);
          setBlogs(lastThreeBlogs);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchBlogs();
  }, []);

  const handleViewBlog = () => {
    navigate("/blog");
  };

  return (
    <div className="App">
      <Header />
      
      <div className="main-container fluid-container">
        <div className="top-banner d-flex justify-content-center flex-wrap align-content-center">
          <h1 className="banner-hd">Our Services</h1>
        </div>
        <div className="inner-container">
          <div className="row text-center mt-5 mb-5">
            <h2 className="custom-main-hd">Give ideas the power to come true</h2>
            <h5 className="custom-top-para">TANNIT give you the tools and visibility you need to achieve your fundraising goals.</h5>
          </div>
          
          <div className="container custom-section-ind">
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <div className="row p-3 properties-list rounded-3 mb-3">
                  <div className="col-lg-2 col-sm-12 ">
                    <img width="60" height="60" src="assets/icons-2/wallert icon.png" alt="img" />
                  </div>
                  <div className="col-lg-10 col-sm-12 p-0">
                    <h3 className="first-left-hd">Properties</h3>
                    <p className="first-left-para">Rely on our experts to choose an environmentally-friendly and profitable property for you.</p>
                  </div>
                </div>
                <div className="row p-3 properties-list rounded-3 mb-3">
                  <div className="col-lg-2 col-sm-12">
                    <img width="60" height="60" src="assets/icons-2/mark icon.png" alt="img" />
                  </div>
                  <div className="col-lg-10 col-sm-12 p-0">
                    <h3 className="first-left-hd">Wallet</h3>
                    <p className="first-left-para">Rely on our experts to choose an environmentally-friendly and profitable property for you.</p>
                  </div>
                </div>
                <div className="row p-3 properties-list rounded-3 mb-3">
                  <div className="col-lg-2 col-sm-12">
                    <img width="60" height="60" src="assets/icons-2/dash icon.png" alt="img" />
                  </div>
                  <div className="col-lg-10 col-sm-12 p-0">
                    <h3 className="first-left-hd">Marketplace</h3>
                    <p className="first-left-para">Rely on our experts to choose an environmentally-friendly and profitable property for you.</p>
                  </div>
                </div>
                <div className="row p-3 properties-list rounded-3 mb-3">
                  <div className="col-lg-2 col-sm-12">
                    <img width="60" height="60" src="assets/icons-2/wallert icon.png" alt="img" />
                  </div>
                  <div className="col-lg-10 col-sm-12 p-0">
                    <h3 className="first-left-hd">Dashboard</h3>
                    <p className="first-left-para">Rely on our experts to choose an environmentally-friendly and profitable property for you.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-sm-12 d-flex align-items-center">
                <img width="100%" src="assets/icons-2/first right banner.png" alt="img" />
              </div>
            </div>
          </div>
           
          <div className="second-row mt-5 mb-5 custom-section-ind">
            <div className="container">
              <div className="row">
                <div className="test-name row p-0">
                  <h3 className="test-hd">Davis Wokman</h3>
                  <h6 className="test-p">CEO Of Tannit</h6>
                </div>
                <div className="test-comment ps-5 pe-5">
                  <i className="fa fa-quote-left" ></i>
                  <p>Our mission is to inspire, educate, and empower users to actively participate in the adoption of eco-friendly goods. Through our inclusive and user-friendly platform, we provide valuable information, comprehensive resources, and lucrative investment opportunities in the realm of environmentally sustainable products.</p>
                </div>
              </div>
            </div>
          </div>
           
          <div className="third-row mt-5 mb-5 custom-section-ind">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <img width="100%" src="assets/icons-2/third left banner.png" alt="img" />
                </div>
                <div className="col-lg-6 col-sm-12 third-left">
                  <h5 className="small-hd">Invest</h5>
                  <h2 className="custom-main-hd mb-5">We believe that investing is the key to financial growth and stability</h2>
                  <div className="d-flex mb-3">
                    <img className="side-red-icon" src="assets/icons-2/checkicon.png" alt="img" />
                    <p className="icon-box small-main-p ms-3">Tannit meticulously analyzes and selects properties that align with eco-friendly practices.</p>
                  </div>
                  <div className="d-flex mb-3">
                    <img className="side-red-icon" src="assets/icons-2/checkicon.png" alt="img" />
                    <p className="icon-box small-main-p ms-3">Tannit meticulously analyzes and selects properties that align with eco-friendly practices.</p>
                  </div>
                  <div className="d-flex mb-3">
                    <img className="side-red-icon" src="assets/icons-2/checkicon.png" alt="img" />
                    <p className="icon-box small-main-p ms-3">Tannit meticulously analyzes and selects properties that align with eco-friendly practices.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <div className="fourth-row mt-5 mb-lg-5 mb-sm-1 custom-section-ind">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <img width="100%" src="assets/icons-2/fourth rigth banner.png" alt="img" />
                </div>
                <div className="col-lg-6 col-sm-12 third-left">
                  <h5 className="small-hd">Collaborate</h5>
                  <h2 className="custom-main-hd mb-lg-5 mb-sm-1">A vibrant community</h2>
                  <p className="small-main-p">Collaboration fosters a sense of community and common goals, encouraging a cooperative and supportive environment among investors.</p>
                  <p className="small-main-p">Our marketplace reinforces the feeling of belonging and engagement in the platform. By promoting collaboration between users, creates a dynamic environment where investors can help each other, and maximize their investment opportunities.</p>
                  <button type="button" className="btn btn-primary">Discover</button>
                </div>
              </div>
            </div>
          </div>

          <div className="fiveth-row mt-5 mb-5 custom-section-ind">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-sm-12 third-left">
                  <h5 className="small-hd">Our experts</h5>
                  <h2 className="custom-main-hd mb-4">We are all set for one goal</h2>
                  <p className="small-main-p">Our platform is committed to providing the best possible experience in the field of participatory real estate. To achieve this goal, we have partnered with renowned experts from the real estate industry. These experts bring their extensive experience, in-depth knowledge, and unparalleled insights to advise and guide our users throughout their investment journey.</p>
                  <button type="button" className="btn btn-primary">Discover</button>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <img width="100%" src="assets/icons-2/fivth right banner.png" alt="img" />
                </div>
              </div>
            </div>
          </div>


          <div className="sixth-row mt-lg-5 mt-sm-1 mb-5 custom-section-ind">
            <div className="container">
              <div className="row text-center mb-5">
                <h5 className="small-hd">To read</h5>
                <h2 className="custom-main-hd">You can learn more from here</h2>
              </div>
              <div className="d-flex post-section">
                {blogs.map((blog) => (
                  <div key={blog.id} className="col-lg-4 col-sm-12 rounded-4 shadow-lg">
                    <img 
                      className='rounded-top-4' 
                      src={blog.imageUrl} 
                      alt={blog.title} 
                      style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                    />
                    <div className="post-detail p-4">
                      <h3>{blog.title}</h3>
                      <p>{blog.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center mt-5">
                <button 
                  type="button" 
                  className="btn btn-primary post-btn"
                  onClick={handleViewBlog}
                >
                  View full blog <img width="15" src="assets/icons-2/post btn icon.png" alt="img" />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Services;